import React from "react";
import "./Pricing.css";
import Faq from "../Faq/Faq";

const Pricing = () => {
  return (
    <div className="pricing" id="Pricing">
      <div className="pricing-container">
        {/* Hero Section */}
        <header className="hero-section">
          <h1>Choose your plan</h1>
          <p>
            Unlock exclusive features, boost your profile, and earn with{" "}
            <strong>Hobbix</strong>, our in-app currency.
          </p>
        </header>

        {/* Pricing Cards */}
        <div className="pricing-cards">
          {/* Free Membership */}
          <div className="pricing-card">
            <h2>Free Membership</h2>
            <p>Free</p>
            <ul>
              <li>✓&nbsp;&nbsp;&nbsp;20 Hobbix for new users</li>
              <li>✓&nbsp;&nbsp;&nbsp;Access to basic features</li>
              <li>✓&nbsp;&nbsp;&nbsp;Join public hobby groups</li>
            </ul>

            <a
              href="https://hobbestie.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="cta-button">Join for Free</button>
            </a>
          </div>

          {/* Premium Membership */}
          <div className="pricing-card">
            <h2>Premium Membership</h2>
            <p>IDR 100k</p>
            <ul>
              <li>✓&nbsp;&nbsp;&nbsp;Get 500 Hobbix</li>
              <li>✓&nbsp;&nbsp;&nbsp;Priority exposure in searches</li>
              <li>✓&nbsp;&nbsp;&nbsp;Exclusive hobby groups & events</li>
              <li>✓&nbsp;&nbsp;&nbsp;Customizable profile themes</li>
            </ul>
            <a
              href="https://hobbestie.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="cta-button">Get Premium</button>
            </a>
          </div>
          <div className="blur1"></div>
          <div className="blur2"></div>
        </div>
      </div>
      {/* FAQ Section */}
      <Faq />
    </div>
  );
};

export default Pricing;
